import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const EditIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M14.83,19.99c1.21,0,2.19-.99,2.19-2.19V7.66l-1.46,1.46-4.84,4.85c-.4.39-.87.67-1.37.83l-2.05.63c-.18.06-.39.1-.64.1-.58,0-1.15-.23-1.56-.64-.56-.56-.77-1.39-.55-2.16l.64-2.07c.15-.51.44-.99.83-1.37l4.84-4.84,1.47-1.46H2.19c-1.21,0-2.19.99-2.19,2.19v12.64c0,1.21.99,2.19,2.19,2.19h12.64Z" />
  <path d="M16.82.54l-3.89,3.89-5.88,5.87c-.21.21-.37.48-.46.77l-.63,2.04c-.07.26,0,.54.18.73.14.14.33.21.52.21.07,0,.15,0,.21-.03l2.05-.63c.29-.09.55-.25.77-.46l5.87-5.88,3.89-3.89c.35-.35.55-.82.55-1.32s-.2-.96-.55-1.32c-.7-.71-1.93-.71-2.63,0Z" />
 </svg>,
 "Edit"
);
